"use client";

import {
  Pagination as UIPagination,
  type PaginationProps as UIPaginationProps,
  Text
} from "@marketplace/ui";
import { useTranslation } from "react-i18next";

type PaginationProps = UIPaginationProps & {
  currentPageTotal: number | undefined;
  totalData: number | undefined;
};

export const Pagination = ({
  currentPageTotal = 0,
  totalData = 0,
  ...other
}: PaginationProps) => {
  const { t } = useTranslation("common");

  return (
    <div className="w-full flex justify-between items-center">
      <Text className="text-fjord-grey-500">
        {t("pagination.totalDataLabel", {
          current: currentPageTotal,
          total: totalData
        })}
      </Text>
      <UIPagination {...other} />
    </div>
  );
};
